import { createContext, useContext } from 'react';

export interface ActiveLanguageContextValue {
  activeLanguageCode?: string;
  activeLanguage?: API.LanguageItem;
  languages: API.LanguageItem[];
}

export const ActiveLanguageContext = createContext<ActiveLanguageContextValue>({
  activeLanguageCode: undefined,
  activeLanguage: undefined,
  languages: [],
});

export const useActiveLanguageContext = () => useContext(ActiveLanguageContext);
